import { ContainerData, MetadataCollection } from "../../../../api/data-types";

export class PagingStack {
  previousTokens: string[];

  public constructor(aTokenStack: string[]) {
    this.previousTokens = aTokenStack;
  }
}

// export interface ContainerData {
//   containersList: string[];
// }

export interface PathArrayProps {
  pathElements: string[];
  path?: string;
}

export interface BrowseUrlSearchParameters {
  container: string;
  folder: string;
  limit: string;
}

export class BrowsePageSearchParameters implements BrowseUrlSearchParameters {
  container: string;
  folder: string;
  limit: string;

  constructor(aContainer: string, aFolder: string, aLimit: string) {
    this.container = aContainer;
    this.folder = aFolder;
    this.limit = aLimit;
  }

  public updateSearchProperties = (searchParams: URLSearchParams) => {
    this.container = searchParams.get("container") ?? "";
    this.folder = searchParams.get("folder") ?? "";
    this.limit = searchParams.get("limit") ?? this.limit;
  };
}

export class BrowsePageState {
  selectedLimit: number;
  containerData: ContainerData;
  currentUrlSearchParameters: BrowsePageSearchParameters;
  isContainerLoaded: boolean;
  currentPagingStack: PagingStack;

  public constructor(
    aLimit: number,
    aContainerData: ContainerData,
    aSearchParams: BrowsePageSearchParameters,
    aContainerLoaded: boolean,
    aPagingStack: PagingStack
  ) {
    this.selectedLimit = aLimit;
    this.containerData = aContainerData;
    this.currentUrlSearchParameters = aSearchParams;
    this.isContainerLoaded = aContainerLoaded;
    this.currentPagingStack = aPagingStack;
  }
}

export class BrowserTableState {
  isFileSelected: boolean;
  selectedRowKeys: React.Key[];
  selectedFileMetadata: MetadataCollection;

  public constructor(
    aFileSelected: boolean,
    aSelectedKeys: React.Key[],
    aMetadata: MetadataCollection
  ) {
    this.isFileSelected = aFileSelected;
    this.selectedRowKeys = aSelectedKeys;
    this.selectedFileMetadata = aMetadata;
  }
}

export const emptySearchProperties: BrowseUrlSearchParameters = {
  container: "",
  folder: "",
  limit: "100",
};
